import React from 'react'
import AddDesignationForm from '../../../component/form/master/designation/AddDesignationForm'

export default function AddDesignation() {
    return (
        <>
            <div className='container-fluid'>
                <div className="row">
                    <div className="col-md-12">
                        <AddDesignationForm />
                    </div>
                </div>
            </div>
        </>
    )
}
